import { Operator } from '@procureai/query-builder';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AstroUserAvailabilityFilterField } from '@/generated/gql/graphql';
import { AstronautUserAutocomplete } from '~/components/AstronautUserAutocomplete';
import {
  listOperators,
  operators,
  queryFieldFactory,
  UseDataGridQueryBuilderConfig,
} from '~/components/DataGridQueryBuilder';

enum UserAvailabilityQueryFieldGroup {
  USER = 'user',
}

export const useUserAvailabilityDataGridQueryBuilderConfig: UseDataGridQueryBuilderConfig = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    const createField = queryFieldFactory(t, { i18nPrefix: 'UserAvailabilityQueryBuilder' });
    return {
      fields: [
        // ---------- RESPONSIBLE ----------
        createField({
          name: AstroUserAvailabilityFilterField.userPrimarySourceReference,
          grp: UserAvailabilityQueryFieldGroup.USER,
          operators: operators.idAuto,
        }),
      ],
      renderValueEditor: ({ field, operator, ...otherProps }) => {
        if (operator === Operator.EMPTY || operator === Operator.NOT_EMPTY) {
          return null;
        }
        switch (field) {
          //
          case AstroUserAvailabilityFilterField.userPrimarySourceReference:
            return (
              <AstronautUserAutocomplete
                multiple={listOperators[operator]}
                hasEmptyOption
                translationPrefix="ResponsibleUsersSelect.options"
                {...otherProps}
              />
            );
          default:
            return null;
        }
      },
    };
  }, [t]);
};
